module.exports = __webpack_public_path__ + "static/media/17.d0f3162b.wav";